module.exports = __webpack_public_path__ + "static/espn-0d49dee8b1b49d9db8fdffec76b92b65.png";